import type { TestimonialsProps } from "./Testimonials.d";
import { Testimonials } from "./Testimonials";

export { TestimonialsProps, Testimonials };
